<template>
  <div>
    <div class="owner_title">压稿管理</div>
    <!-- 筛选 -->
    <div class="task_filtrate" @click="show_filter_form()">
      <i class="iconfont icon-shaixuan1"></i>
      <span>筛选</span>
    </div>

    <!-- 筛选表单 -->
    <div class="task_filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="书名" prop="connectionessay_name">
          <el-input v-model="filter_form.connectionessay_name"></el-input>
        </el-form-item>
        <el-form-item label="写手昵称" prop="writer_nickname">
          <el-input v-model="filter_form.writer_nickname"></el-input>
        </el-form-item>
        <el-form-item label="写手姓名" prop="writer_name">
          <el-input v-model="filter_form.writer_name"></el-input>
        </el-form-item>
        <el-form-item label="写手支付宝" prop="alipay_account">
          <el-input v-model="filter_form.alipay_account"></el-input>
        </el-form-item>
        <el-form-item label="是否结算">
          <el-select
            v-model="filter_form.deposit_status"
            placeholder="是否结算"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="未结算" value="0"></el-option>
            <el-option label="已结算" value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filter_form.createtime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>

    <div class="seas_box">
      <!-- 表格数据  -->
      <el-table height="550" :data="dataShow" border style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="connectionessay_name"
          label="书名"
          align="center"
          width="250"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="writer_nickname"
          label="写手昵称"
          width="150"
          align="center"
          sortable
        >
        </el-table-column>

        <el-table-column
          property="writer_name"
          label="写手姓名"
          width="150"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="alipay_account"
          label="写手支付宝"
          align="center"
          width="150"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="deposit_money"
          label="压稿金额"
          width="150"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="w_fee"
          label="可申请压稿金额"
          align="center"
          width="150"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="deposit_status"
          label="是否结算"
          width="120"
          align="center"
          sortable
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.deposit_status == '0' ? 'danger' : 'success'"
            >
              {{ scope.row.deposit_status == "0" ? "未结算" : "已结算" }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          property="word_number"
          label="字数"
          width="100"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="start_chapters"
          label="开始章节"
          width="120"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="end_chapters"
          label="结束章节"
          width="120"
          align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          sortable
          width="180"
        >
        </el-table-column>
        <el-table-column
          :fixed="equipmentType == 1 ? false : 'right'"
          label="操作"
          align="center"
          width="300"
        >
          <template slot-scope="scope">
            <div class="control_btn_box">
              <div
                @click="payDialog(scope.row)"
                class="pay_btn"
                :class="[
                  {
                    disabled_btn: scope.row.w_fee == 0
                  }
                ]"
              >
                <i class="iconfont icon-jinqian-yuan"></i>结算
              </div>
              <div @click="detailDialog(scope.row)" class="detail_btn">
                <i class="iconfont icon-zongcejieguochakan"></i>查看详情
              </div>
              <div @click="recordDialog(scope.row)" class="detail_btn">
                <i class="iconfont icon-jilu"></i>申请记录
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 查看详情弹窗 -->
      <el-dialog
        :visible.sync="detailDialogVisible"
        title="压稿详情"
        @close="cancelDialog"
        width="90%"
      >
        <el-table :data="dataShowDialog" border>
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column
            property="connectionessay_name"
            label="书名"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            property="writer_nickname"
            label="写手昵称"
            align="center"
            sortable
          >
          </el-table-column>

          <el-table-column
            property="writer_name"
            label="写手姓名"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            property="alipay_account"
            label="写手支付宝"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            property="deposit_money"
            label="压稿金额"
            align="center"
            sortable
          >
          </el-table-column>

          <el-table-column
            property="deposit_status"
            label="是否结算"
            align="center"
            sortable
          >
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.deposit_status == '0' ? 'danger' : 'success'"
              >
                {{ scope.row.deposit_status == "0" ? "未结算" : "已结算" }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column
            property="word_number"
            label="字数"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            property="start_chapters"
            label="开始章节"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            property="end_chapters"
            label="结束章节"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            property="createtime"
            label="创建时间"
            align="center"
            sortable
            width="180"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination_dialog"
          @size-change="handleSizeChangeDetail"
          @current-change="handleCurrentChangeDetail"
          :current-page="currentPageDetail"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSizeDetail"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDetail"
        >
        </el-pagination>
      </el-dialog>
      <!-- 申请记录弹窗 -->
      <el-dialog
        :visible.sync="recordDialogVisible"
        title="申请记录"
        @close="cancelDialog"
        width="90%"
      >
        <el-table :data="recordDataDialog" border>
          <el-table-column type="index" label="序号" align="center" width="50">
          </el-table-column>
          <el-table-column
            property="connectionessay_name"
            label="书名"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            property="writer_nickname"
            label="写手昵称"
            align="center"
            sortable
          >
          </el-table-column>

          <el-table-column
            property="writer_name"
            label="写手姓名"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            property="where_alipay_account"
            label="写手支付宝"
            align="center"
            sortable
          >
          </el-table-column>
          <el-table-column
            property="money"
            label="申请金额"
            align="center"
            sortable
          >
          </el-table-column>

          <el-table-column
            property="status"
            label="是否结算"
            align="center"
            sortable
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.status == '0' ? 'danger' : 'success'">
                {{ scope.row.status == "0" ? "申请中" : "已结算" }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            property="createtime"
            label="创建时间"
            align="center"
            sortable
            width="180"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination_dialog"
          @size-change="handleSizeChangeRecord"
          @current-change="handleCurrentChangeRecord"
          :current-page="currentPageRecord"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSizeRecord"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalRecord"
        >
        </el-pagination>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination
        class="pagination_box"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  deposit_list,
  deposit_js,
  deposit_details,
  press_application
} from "@/utils/writer";
export default {
  data() {
    return {
      writerId: "", //所属写手部id
      temporaryList: [], //预支稿费列表
      detailList: [], //详情列表
      isFilterForm: true, //筛选表单
      detailDialogVisible: false, //查看详情弹窗
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      // 筛选
      filter_form: {
        connectionessay_name: "", //书名
        writer_nickname: "", //写手昵称
        writer_name: "", //写手姓名
        alipay_account: "", //写手支付宝
        deposit_status: "", //是否结算
        createtime: "" //创建时间
      },
      dataShowDialog: [], //查看详情弹窗数据
      totalPageDataDetail: [], // 分页数据(全部数据已经分好页)
      pageNumDetail: 1, // 共几页
      pageSizeDetail: 10, // 每页显示数量
      currentPageDetail: 1, // 当前显示页码
      totalDetail: 1, // 总共多少条数据
      recordDialogVisible: false, //申请记录弹窗
      recordList: [], //申请记录
      recordDataDialog: [], //申请记录列表
      totalPageDataRecord: [], // 分页数据(全部数据已经分好页)
      pageNumRecord: 1, // 共几页
      pageSizeRecord: 10, // 每页显示数量
      currentPageRecord: 1, // 当前显示页码
      totalRecord: 1, // 总共多少条数据
      select_time_data: "",
      time_filter: "", //时间筛选
      equipmentType: 0 //判断移动端还是pc端  0：pc  1：移动
    };
  },
  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
    } else {
      this.equipmentType = 0;
    }
    this.getAdvanceList();
  },
  methods: {
    getAdvanceList() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId
      };
      deposit_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.temporaryList = res.data.data;
          that.calcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 结算弹窗
    payDialog(val) {
      var that = this;
      if (val.w_fee == 0) {
        return false;
      }
      let obj = {
        departmentuser_id: that.writerId, //所属写手部id
        connectionrecords_ids: val.w_ids,
        connectionessay_id: val.connectionessay_id,
        writer_expand_id: val.writer_expand_id,
        money: val.w_fee
      };
      deposit_js(obj).then(res => {
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          that.goSearch();
        } else {
          this.$message.error(res.data.msg);
          that.goSearch();
        }
      });
    },
    // 申请记录弹窗
    recordDialog(val) {
      var that = this;
      that.recordDialogVisible = true;
      let obj = {
        departmentuser_id: that.writerId,
        connectionessay_id: val.connectionessay_id
      };
      press_application(obj).then(res => {
        if (res.data.code == 1) {
          that.totalRecord = res.data.data.length;
          that.recordList = res.data.data;
          console.log(that.recordList);

          that.calcPageDataRecord();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 查看详情弹窗
    detailDialog(val) {
      var that = this;
      that.detailDialogVisible = true;
      let obj = {
        departmentuser_id: that.writerId,
        connectionessay_id: val.connectionessay_id,
        writer_expand_id: val.writer_expand_id
      };
      deposit_details(obj).then(res => {
        if (res.data.code == 1) {
          that.totalDetail = res.data.data.length;
          that.detailList = res.data.data;
          that.calcPageDataDetail();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 筛选
    goSearch() {
      var that = this;
      var date1, date2;
      that.select_time_data = that.filter_form.createtime;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];
      if (date1 == undefined && date2 == undefined) {
        that.time_filter = "";
      } else {
        that.time_filter = date1 + " - " + date2;
      }
      console.log("that.time_filter", that.time_filter);
      that.filter_form.createtime = that.time_filter;
      let obj = {
        departmentuser_id: that.writerId,
        ...that.filter_form
      };
      deposit_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.temporaryList = res.data.data;
          that.calcPageData();
          that.filter_form.createtime = that.select_time_data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    cancelDialog() {
      this.goSearch();
    },
    // 列表分页
    calcPageData() {
      if (this.temporaryList.length > 1) {
        this.pageNum =
          Math.ceil(this.temporaryList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.temporaryList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    },
    // 申请记录分页
    calcPageDataRecord() {
      if (this.recordList.length > 1) {
        this.pageNumRecord =
          Math.ceil(this.recordList.length / this.pageSizeRecord) || 1;
      }
      for (let i = 0; i < this.pageNumRecord; i++) {
        this.totalPageDataRecord[i] = this.recordList.slice(
          this.pageSizeRecord * i,
          this.pageSizeRecord * (i + 1)
        );
      }
      this.recordDataDialog = this.totalPageDataRecord[
        this.currentPageRecord - 1
      ];
      console.log(this.recordDataDialog);
    },
    handleSizeChangeRecord(val) {
      this.pageSizeRecord = val;
      this.calcPageDataRecord();
    },
    handleCurrentChangeRecord(val) {
      this.currentPageRecord = val;
      this.recordDataDialog = this.totalPageDataRecord[val - 1];
    },
    // 列表查看详情分页
    calcPageDataDetail() {
      if (this.detailList.length > 1) {
        this.pageNumDetail =
          Math.ceil(this.detailList.length / this.pageSizeDetail) || 1;
      }
      for (let i = 0; i < this.pageNumDetail; i++) {
        this.totalPageDataDetail[i] = this.detailList.slice(
          this.pageSizeDetail * i,
          this.pageSizeDetail * (i + 1)
        );
      }
      this.dataShowDialog = this.totalPageDataDetail[
        this.currentPageDetail - 1
      ];
    },
    handleSizeChangeDetail(val) {
      this.pageSizeDetail = val;
      this.calcPageDataDetail();
    },
    handleCurrentChangeDetail(val) {
      this.currentPageDetail = val;
      this.dataShowDialog = this.totalPageDataDetail[val - 1];
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.seas_box {
  margin: 0px 15px;
}
.task_btn {
  /* width: 90px;
  height: 25px;
  text-align: center;
  line-height: 5px; */
  background: #f3f8ff;
  color: #157df8;
}
.mywriter_btn {
  width: 110px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #157df8;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
.mywriter_btn i {
  font-size: 12px;
}
.info_icon {
  font-size: 12px;
}
.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}
.task_filtrate i {
  font-size: 14px;
}
.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.task_filter_form {
  background: #ffffff;
  margin: 0px 15px;
  padding-top: 15px;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.sea_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.remark_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
  margin-left: 5px;
}
.remark_btn i {
  font-size: 12px;
}

.seas_box .el-tag {
  width: 90px;
  margin: 5px auto;
}
.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 20px;
  border-radius: 10px;
  margin-left: 15px;
}
.file_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.detail_btn {
  width: 120px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
  margin-right: 5px;
}
.pay_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #e7f2ff;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  border-radius: 10px;
  margin-right: 10px;
}
.pay_btn i,
.detail_btn i {
  font-size: 12px;
  margin-right: 5px;
}
.control_btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.disabled_btn {
  cursor: not-allowed;
  width: 90px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #eeeeee;
  color: #8893a7;
  border-radius: 10px;
  margin-right: 5px;
  font-size: 12px;
  /* pointer-events: none; */
}
.disabled_btn i {
  font-size: 12px;
}
.pagination_dialog {
  text-align: right;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .seas_box {
    margin-bottom: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/writer/ManuscriptDeposit.vue